// extracted by mini-css-extract-plugin
module.exports = {"icon":"SidebarTrigger_icon__t2vI4","light":"SidebarTrigger_light__hadX9","dark":"SidebarTrigger_dark__0vl6v"};